export default __webpack_public_path__ + "img/be58bbf0b13d98c5e112ab1d619d489b.png";